export { TooltipContainerComponent } from './tooltip.component';
export { TooltipDirective } from './tooltip.directive';
export { MDBTooltipModule } from './tooltip.module';
export { TooltipConfig } from './tooltip.service';



// WEBPACK FOOTER //
// ./src/app/typescripts/free/tooltip/index.ts